import { objKeySort } from './common.js'

class Param {
  constructor (options) {
    this.app_key = null
    this.format = 'json'
    this.version = 'v2'
    this.timestamp = Math.round(new Date().getTime() / 1000)
    this.nonce = new Date().getMilliseconds() + '0' + Math.floor(Math.random() * 10000)
    this.sign = null
    this.options = options
  }

  static init (options = {}) {
    return new Param(options)
  }

  common (app_key, sign) {
    this.app_key = app_key
    this.sign = sign
    let str = ''
    let newStr = ''
    const param = objKeySort({
      app_key: this.app_key,
      format: this.format,
      version: this.version,
      timestamp: this.timestamp,
      nonce: this.nonce,
      ...this.options
    })
    for (const i of Object.keys(param)) {
      str += `${i}=${param[i]}&`
    }
    newStr = str + this.sign
    this.sign = md5(newStr)
    str += `sign=${this.sign}`
    return str
  }

  uc () {
    return this.common('SMBQpaBWvVZPkpcBvDwQswDWxm', 'dcdAlgyn1GxxageKCqKxHYSIInCqDtkIgZaubdkpqVbDJ')
  }

  re () {
    return this.common('AkdhaZPwXuUCMTrmitfepEnFQs', 'FHADKcE1xONIUxTawFbigFE1GXvzOXjSASVmfXoQcKfoJ')
  }

}

export default Param



// WEBPACK FOOTER //
// ./src/assets/js/Param.js